import { InjectionToken } from '@angular/core';
import { Routes } from '@angular/router';
import { KeyValue } from '@angular/common';
import { DEVICE_TYPE_MODEL } from './apollo/models/base-models';

interface RouteTranslation {
  [key: string]: string;
}

interface AllRouteTranslation {
  [key: string]: RouteTranslation;
}

export const TRANSLATE_CONFIG = new InjectionToken("translate config");
export const DESKTOP_ROUTES = new InjectionToken<Routes>("Loading lazy routes");
export const DESKTOP_ROUTER = new InjectionToken("Router");

export const TRANSLATED_ROUTES = new InjectionToken<RouteTranslation>('translatedRoutes');
export const ALL_TRANSLATED_ROUTES = new InjectionToken<AllRouteTranslation>('allTranslatedRoutes');
export const DESKTOP_ROUTE_TOKEN = new InjectionToken<Routes>(null);
export const HOST_NAME = new InjectionToken<string>('hostName');
export const licences = {
  'lemoncasino.io': 'gambia',
  'cache.lemoncasino.io': 'gambia',
  'lemoncasino1.io': 'gambia',
  'lemoncasino2.io': 'gambia',
  'lemoncasino4.io': 'gambia',
  'lemoncasino5.io': 'gambia',
  'lemoncasino6.io': 'gambia',
  'lemolemo.io': 'gambia',
  'cache.lemoncasino1.io': 'gambia',
  'cache.lemoncasino2.io': 'gambia',
  'cache.lemoncasino4.io': 'gambia',
  'orangecasino.io': 'orange_curacao',
  'india.lemoncasino1.io': 'india',
  'bison.win': 'bison_win',
  'playbison.com': 'playbison',
  'bison.casino': 'bison_casino',
  'bisoncasino.io': 'bison_casino',
  'playbison.io': 'playbison',
  'playbison1.io': 'playbison',
  'playbison.club': 'playbison_club',
  'playbull.vip': 'playbull_vip',
  'localhost': 'bison_casino',
};

export const getLicence = (hostname, locale) => {
  let result = licences[hostname]
  if (!result) return 'curacao'
  result = result[locale] || result['default']
  return result
}

export const language_license = {
  "en-IN": "bison_india",
  "hi": "bison_india"
};


export const LICENCE = new InjectionToken<string>('license');
export const LICENCE_CONFIG = new InjectionToken<KeyValue<string, KeyValue<string, string>>>('license-config');
export const COUNTRY_ID = new InjectionToken<string>('en');
export const USER_REGION = new InjectionToken<string>('');
export const DEVICE_TYPE = new InjectionToken<DEVICE_TYPE_MODEL>(DEVICE_TYPE_MODEL.MOBILE);
